import React from 'react';

const ProofOfDeliveryBookingTableComponentLoadable = React.lazy(() => import('./ProofOfDeliveryBookingTableComponent'));

export {
    ProofOfDeliveryBookingTableComponentLoadable
}